import { injectIntl } from 'react-intl';
import {
  Button,
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Grid,
  InputAdornment,
  TextField,
  Typography
} from '@mui/material';
import React from 'react';
import SelectButtonGroup from '../../../../components/SelectButtonGroup/SelectButtonGroup';
import {
  getValidThemeColorOption,
  HOBBIES_CHOICES,
  THEME_COLOR_CHOICES,
  THEME_COLOR_IMAGES,
  THEME_COLOR_PALETTES,
  THEME_STYLE_CHOICES
} from '../../../../constants/my-details';
import { getHobbyIntl } from '../../../../utils/my-details';
import AladdinHint from '../../../../components/AladdinHint/AladdinHint';
import _ from 'lodash';
import { sanitize } from 'dompurify';

const HOSTNAME = process.env.PFPLUS_URL;

const FullWidthStyle = {
  width: '100%'
};

const DisclaimerTypoStyle = {
  fontSize: '80%'
};

const ProfilePlusButtonStyle = {
  minWidth: 'unset',
  padding: '4px 8px',
  lineHeight: 1.25,
  marginBottom: 8
};

const MyDetailsSocial = props => {
  const { intl, userDetails, details, error, onChangeDetails, updateError, onResize } = props;

  const {
    hobbies,
    customizedHobby,
    university,
    secondarySchool,
    familiarPlaces,
    otherHashtags,
    instagram,
    facebookLink,
    realLinkedinLink,
    linkedinLink,
    themeColor,
    themeStyle
  } = details || {};

  const createSimpleOnChangeHandler = (key, emptyValue) => event =>
    onChangeDetails({ [key]: event.target.value || emptyValue });
  const onChangeHobbies = createSimpleOnChangeHandler('hobbies', []);
  const onChangeCustomizedHobby = createSimpleOnChangeHandler('customizedHobby', '');
  const onChangeUniversity = createSimpleOnChangeHandler('university', '');
  const onChangeSecondarySchool = createSimpleOnChangeHandler('secondarySchool', '');
  const onChangeFamiliarPlaces = createSimpleOnChangeHandler('familiarPlaces', '');
  const onChangeOtherHashtags = createSimpleOnChangeHandler('otherHashtags', '');
  const onChangeInstagram = createSimpleOnChangeHandler('instagram', '');
  const onChangeFacebookLink = createSimpleOnChangeHandler('facebookLink', '');
  const onChangeRealLinkedinLink = createSimpleOnChangeHandler('realLinkedinLink', '');
  const onChangeLinkedinLink = createSimpleOnChangeHandler('linkedinLink', '');
  const onChangeThemeColor = createSimpleOnChangeHandler('themeColor', 'blue');
  // const onChangeThemeStyle = createSimpleOnChangeHandler('themeStyle', 'classic');
  // const onHobbiesMax = () => updateError({ hobbies: true });
  const profilePlus = () => onChangeDetails({ linkedinLink: `${HOSTNAME}/adviser/${_.get(userDetails, '_id')}` });

  return (
    <Grid container spacing={3} sx={{ flexDirection: 'column' }}>
      <Grid>
        <AladdinHint title={intl.formatMessage({ id: 'mda-social-title' })} />
      </Grid>
      <Grid>
        <Accordion className="mc-expansion-panel" expanded={true}>
          <AccordionSummary>
            <Typography className="field-label" color={!!error.hobbies ? 'error' : undefined}>{`${intl.formatMessage({
              id: 'hobbies'
            })}*`}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Grid container spacing={2} sx={{ flexDirection: 'column', alignItems: 'flex-start' }}>
              <Grid>
                <Typography
                  color="textSecondary"
                  dangerouslySetInnerHTML={{ __html: sanitize(intl.formatMessage({ id: 'mda-mc-6-hint' })) }}
                />
              </Grid>
              <Grid>
                <SelectButtonGroup
                  multi={true}
                  max={6}
                  choices={HOBBIES_CHOICES.map(hobby => ({
                    value: hobby,
                    label: intl.formatMessage({ id: getHobbyIntl(hobby) })
                  }))}
                  value={hobbies}
                  onChange={onChangeHobbies}
                  // onMax={onHobbiesMax}
                />
              </Grid>
              <Grid>
                <TextField
                  label={intl.formatMessage({ id: 'customizedHobby' })}
                  value={customizedHobby || ''}
                  onChange={onChangeCustomizedHobby}
                  placeholder=""
                  slotProps={{
                    htmlInput: { maxLength: 20 },
                    inputLabel: { shrink: true }
                  }}
                />
              </Grid>
            </Grid>
          </AccordionDetails>
        </Accordion>
      </Grid>
      <Grid>
        <Typography color="primary" align="center">
          {intl.formatMessage({ id: 'mda-my-footprint' })}
        </Typography>
      </Grid>
      <Grid>
        <TextField
          label={intl.formatMessage({ id: 'familiar-places' })}
          value={familiarPlaces || ''}
          onChange={onChangeFamiliarPlaces}
          placeholder="#沙田友 #Sydney #Vancouver"
          slotProps={{
            inputLabel: { shrink: true }
          }}
        />
      </Grid>
      <Grid>
        <TextField
          label={intl.formatMessage({ id: 'university' })}
          value={university || ''}
          onChange={onChangeUniversity}
          placeholder="#澳大 #MIT"
          slotProps={{
            inputLabel: { shrink: true }
          }}
        />
      </Grid>
      <Grid>
        <TextField
          label={intl.formatMessage({ id: 'sec-pri-school' })}
          value={secondarySchool || ''}
          onChange={onChangeSecondarySchool}
          placeholder="#保富中學 #保富小學"
          slotProps={{
            inputLabel: { shrink: true }
          }}
        />
      </Grid>
      <Grid>
        <TextField
          label={intl.formatMessage({ id: 'other-hashtags' })}
          value={otherHashtags || ''}
          onChange={onChangeOtherHashtags}
          placeholder="#NZ工作假期 #加拿大Exchange"
          slotProps={{
            inputLabel: { shrink: true }
          }}
        />
      </Grid>
      <Grid>
        <Typography color="primary" align="center">
          {intl.formatMessage({ id: 'mda-social-platforms' })}
        </Typography>
      </Grid>
      <Grid>
        <TextField
          label={intl.formatMessage({ id: 'instagram' })}
          value={instagram}
          onChange={onChangeInstagram}
          placeholder="portfoplus"
          slotProps={{
            inputLabel: { shrink: true }
          }}
        />
      </Grid>
      <Grid>
        <TextField
          label={intl.formatMessage({ id: 'Facebook Link' })}
          value={facebookLink}
          onChange={onChangeFacebookLink}
          placeholder="https://www.facebook.com/portfoplus"
          slotProps={{
            inputLabel: { shrink: true }
          }}
        />
      </Grid>
      <Grid>
        <TextField
          label={intl.formatMessage({ id: 'linkedin' })}
          value={realLinkedinLink}
          onChange={onChangeRealLinkedinLink}
          placeholder="https://www.linkedin.com/company/portfoplus"
          slotProps={{
            inputLabel: { shrink: true }
          }}
        />
      </Grid>
      <Grid>
        <TextField
          label={intl.formatMessage({ id: 'Adviser-Link' })}
          value={linkedinLink}
          onChange={onChangeLinkedinLink}
          placeholder="https://www.myweb.com"
          slotProps={{
            input: {
              endAdornment: (
                <InputAdornment position="end">
                  <Button color="primary" variant="contained" style={ProfilePlusButtonStyle} onClick={profilePlus}>
                    PF+
                  </Button>
                </InputAdornment>
              )
            },

            inputLabel: { shrink: true }
          }}
        />
      </Grid>
      <Grid>
        <Grid container spacing={2} sx={{ flexDirection: 'column', alignItems: 'center' }}>
          <Grid style={FullWidthStyle}>
            <Typography className="field-label">{intl.formatMessage({ id: 'mda-theme-color' })}</Typography>
          </Grid>
          <Grid>
            <SelectButtonGroup
              choices={THEME_COLOR_CHOICES.map(tag => ({
                value: tag,
                label: intl.formatMessage({ id: `tc-${tag}` }),
                selectedColor: THEME_COLOR_PALETTES[tag][0]
              }))}
              value={themeColor || THEME_COLOR_CHOICES[0]}
              onChange={onChangeThemeColor}
            />
          </Grid>
          {/*   wait style design 2 to confirm then release the code to let user pick styles

          <Grid style={FullWidthStyle}>
            <Typography className="field-label" alignItems="flex-start">
              {intl.formatMessage({ id: 'mda-theme-style' })}
            </Typography>
          </Grid>
          <Grid>
            <SelectButtonGroup
              choices={THEME_STYLE_CHOICES.map(tag => ({
                value: tag,
                label: intl.formatMessage({ id: `ts-${tag}` }),
                selectedColor: THEME_COLOR_PALETTES[themeColor || 'blue'][0]
              }))}
              value={themeStyle || THEME_STYLE_CHOICES[0]}
              onChange={onChangeThemeStyle}
            />
          </Grid> */}
          <Grid>
            <img
              src={THEME_COLOR_IMAGES[themeStyle || 'classic'][getValidThemeColorOption(details)]['preview']}
              alt="preview"
              style={{ height: 45 }}
            />
          </Grid>
          {/*<Grid style={{ borderBottom: `1px solid ${THEME_COLOR_PALETTES[themeColor || 'blue'][0]}80` }}>*/}
          {/*  <Grid container  sx={{ alignItems: "flex-end",  justifyContent: "center" }} spacing={1}>*/}
          {/*    <Grid>*/}
          {/*      <img src={THEME_COLOR_IMAGES[themeColor || 'blue']['logo']} alt="portfoplus" style={{ height: 45 }} />*/}
          {/*    </Grid>*/}
          {/*    <Grid>*/}
          {/*      <Grid container spacing={1}>*/}
          {/*        {THEME_COLOR_PALETTES[themeColor || 'blue'].map((color, index) => (*/}
          {/*          <Grid key={`${index}-${color}`}>*/}
          {/*            <div style={{ background: color, width: 35, height: 35 }} />*/}
          {/*          </Grid>*/}
          {/*        ))}*/}
          {/*      </Grid>*/}
          {/*    </Grid>*/}
          {/*  </Grid>*/}
          {/*</Grid>*/}
        </Grid>
      </Grid>
      <Grid>
        <Typography style={DisclaimerTypoStyle}>{intl.formatMessage({ id: 'profile-disclaim' })}</Typography>
      </Grid>
    </Grid>
  );
};

export default injectIntl(MyDetailsSocial);
